import { actionTypes } from '../actions';

const initialState = {
  pros: [],
  sortBy: 'activity',
  searchTerm: '',
  page: 1,
  loading: false,
  total: 0,
  featuredServices: [],
};

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    case actionTypes.GET_PROS_SUCCESS:
      return {
        ...state,
        pros: action.payload.results,
        loading: false,
        total: action.payload.total,
        featuredServices: action.payload.featuredServices,
      };
    case actionTypes.SIGN_IN_PUT_RESPONSE:
    case actionTypes.UPDATE_USER_SETTINGS_SUCCESS: {
      const { settings: userSettings, userData } = action.payload;

      const settings = userData ? userData.settings : userSettings;
      const sector = settings && settings.interestSector[0];
      const category = settings && settings.interestCategory[0];

      return {
        ...state,
        filter: !state.filter && sector ? `${sector}${category ? `.${category}` : ''}` : state.filter,
      };
    }

    case actionTypes.GET_PROS:
      return {
        ...state,
        loading: true,
        featuredServices: [],
      };
    case actionTypes.RESET_PRO_SEARCH_PARAMS:
      return {
        ...state,
        ...initialState,
      };
    case actionTypes.SET_PRO_SEARCH_PARAMS: {
      const { type } = action.payload;
      const resetPage = type !== 'page' && state.page !== 1;

      return {
        ...state,
        page: resetPage ? 1 : state.page,
        [action.payload.type]: action.payload.value,
      };
    }
    case actionTypes.LOGGED_OFF:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/pros.js